import { render, staticRenderFns } from "./VMLabel.vue?vue&type=template&id=2a5c11aa&scoped=true&lang=pug&"
import script from "./VMLabel.vue?vue&type=script&lang=js&"
export * from "./VMLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c11aa",
  null
  
)

export default component.exports